// extracted by mini-css-extract-plugin
module.exports = {"title":"title-12_N1"};